<template>
    <div>
        <div class="container container--grid">
            <h3 class="
                col-span-4 text-center text-30 leading-xsmall pb-7 mb-8 border-b border-cream
                sm:text-20 sm:leading-none sm:col-start-2 sm:col-span-4 sm:border-none sm:pb-0 sm:mb-5 sm:text-left
                md:mb-6
                lg:mb-9 lg:text-28 lg:col-start-2 lg:col-span-5
                xxl:40 xxl:mb-14
            ">
                Discover the neighborhood
            </h3>

            <div class="flex flex-wrap col-span-4 mb-20 | sm:row-start-2 sm:col-start-2 sm:col-span-11 sm:gap-5 sm:mb-12 | md:gap-7 | lg:mb-16  lg:gap-11 | xxl:mb-10 xxl:gap-14 xxl:gap-12">
                <a class="w-1/2 mb-5 link cursor-pointer hover:text-black | sm:w-auto sm:mb-0" @click="getMarkers('food-and-drink')" :class="{'is-active' : category === 'food-and-drink'}">Food and drink</a>
                <a class="w-1/2 mb-5 link cursor-pointer hover:text-black | sm:w-auto sm:mb-0" @click="getMarkers('shopping')" :class="{'is-active' : category === 'shopping'}">Shopping</a>
                <a class="w-1/2 mb-5 link cursor-pointer hover:text-black | sm:w-auto sm:mb-0" @click="getMarkers('fitness')" :class="{'is-active' : category === 'fitness'}">Fitness</a>
                <a class="w-1/2 mb-5 link cursor-pointer hover:text-black | sm:w-auto sm:mb-0" @click="getMarkers('transportation', 'train')" :class="{'is-active' : category === 'transportation'}">Transportation</a>
                <a class="w-1/2 mb-5 link cursor-pointer hover:text-black | sm:w-auto sm:mb-0" @click="getMarkers('education')" :class="{'is-active' : category === 'education'}">Education</a>
                <a class="w-1/2 mb-5 link cursor-pointer hover:text-black | sm:w-auto sm:mb-0" @click="getMarkers('schools_and_childcare')" :class="{'is-active' : category === 'schools_and_childcare'}">Schools & Childcare</a>
                <a class="w-1/2 mb-5 link cursor-pointer hover:text-black | sm:w-auto sm:mb-0" @click="getMarkers('parks')" :class="{'is-active' : category === 'parks'}">Parks</a>
                <a class="w-1/2 mb-5 link cursor-pointer hover:text-black | sm:w-auto sm:mb-0" @click="getMarkers('experiences')" :class="{'is-active' : category === 'experiences'}">Experiences</a>
            </div>

            <div v-show="category === 'transportation'"
                 class="flex flex-wrap col-span-4 mb-20 | sm:col-start-2 sm:col-span-11 sm:gap-5 sm:mb-12 | md:gap-7 | lg:mb-16  lg:gap-11 | xxl:mb-10 xxl:gap-14 xxl:gap-12">
                <a class="w-1/2 mb-5 link link--small cursor-pointer hover:text-black | sm:w-auto sm:mb-0" @click="getMarkers('transportation', 'train')" :class="{'is-active' : subCategory === 'train'}">Train Stations</a>
                <a class="w-1/2 mb-5 link link--small cursor-pointer hover:text-black | sm:w-auto sm:mb-0" @click="getMarkers('transportation', 'bikes')" :class="{'is-active' : subCategory === 'bikes'}">Blue bikes</a>
                <a class="w-1/2 mb-5 link link--small cursor-pointer hover:text-black | sm:w-auto sm:mb-0" @click="getMarkers('transportation', 'parkings')" :class="{'is-active' : subCategory === 'parkings'}">Parkings</a>
            </div>
        </div>

        <div class="relative w-full">
            <!--  map-type-id="terrain" -->
            <!-- :icon="`/wp-content/themes/somernovaTheme/assets/images/marker${(openedMarkerID === m.id) ? '-active' : ''}.svg`" -->
            <!-- scaledSize: {width: iconWidth, height: iconWidth} -->
            <GMapMap :center="center" :options="options" :zoom="16" class="w-full h-[80vh]">
                <GMapPolyline
                    v-for="(m, index) in markers"
                    :key="index"
                    :options="{
                        path: m.path.lines,
                        strokeColor: m.path.strokeColor,
                    }"
                />
                
                <GMapMarker
                    :icon="{
                        url: `/wp-content/themes/somernovaTheme/assets/images/somernova-point.svg`,
                    }"
                    :position="{ lat: 42.3823289, lng: -71.1060395 }"
                >
                </GMapMarker>
                
                <GMapMarker
                    :key="index"
                    v-for="(m, index) in markers"
                    :icon="{
                        url: `/wp-content/themes/somernovaTheme/assets/images/marker${(openedMarkerID === m.id) ? '-active' : ''}.svg`,
                    }"
                    :position="m.position"
                    :clickable="true"
                    :draggable="false"
                    @click="openMarker(m.id)"
                    @mouseover="openMarker(m.id);">
                    <GMapInfoWindow
                        :closeclick="true"
                        :opened="openedMarkerID === m.id"
                        :options=" {
                            pixelOffset: {
                                width: 0, height: -7
                            },
                            maxWidth: 320,
                            maxHeight: 25,
                        }"
                    >
                        <div>
                            <p 
                                class="font-System85 text-center text-black uppercase text-16 xxl:text-20"
                                :class="{'!text-left' : m.label.includes(`\n`)}"
                                v-html="m.label">
                            </p>
                        </div>
                    </GMapInfoWindow>
                </GMapMarker>
            </GMapMap>
        </div>
    </div>
</template>

<script>
export default {
    props: [ 'data' ],
    data() {
        return {
            category: 'food-and-drink',
            subCategory: null,
            openedMarkerID: null,
            center: { lat: 42.3823289, lng: -71.1060395 },
            path: [
                {lat: 1, lng: 1.01},
                {lat: 1.02, lng: 1.03},
            ],
            options: {
                zoomControl: true,
                mapTypeControl: false,
                scaleControl: true,
                streetViewControl: false,
                rotateControl: false,
                fullscreenControl: false,
                clickableLabels: false,
                styles: [
                    {
                        "featureType": "administrative",
                        "elementType": "labels.text.fill",
                        "stylers": [
                            {
                                "color": "#444444"
                            }
                        ]
                    },
                    {
                        "featureType": "administrative.country",
                        "elementType": "labels",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "administrative.province",
                        "elementType": "labels",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "administrative.locality",
                        "elementType": "labels",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "administrative.neighborhood",
                        "elementType": "labels",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "administrative.land_parcel",
                        "elementType": "labels",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "landscape",
                        "elementType": "all",
                        "stylers": [
                            {
                                "color": "#f2f2f2"
                            }
                        ]
                    },
                    {
                        "featureType": "landscape",
                        "elementType": "geometry.fill",
                        "stylers": [
                            {
                                "color": "#e8e3dc"
                            }
                        ]
                    },
                    {
                        "featureType": "poi",
                        "elementType": "all",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "poi.park",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "visibility": "simplified"
                            },
                            {
                                "color": "#dbd7cc"
                            }
                        ]
                    },
                    {
                        "featureType": "poi.park",
                        "elementType": "labels",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "poi.park",
                        "elementType": "labels.text.fill",
                        "stylers": [
                            {
                                "visibility": "on"
                            },
                            {
                                "color": "#a2a2a1"
                            }
                        ]
                    },
                    {
                        "featureType": "poi.park",
                        "elementType": "labels.icon",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "road",
                        "elementType": "all",
                        "stylers": [
                            {
                                "saturation": -100
                            },
                            {
                                "lightness": 45
                            }
                        ]
                    },
                    {
                        "featureType": "road",
                        "elementType": "geometry.fill",
                        "stylers": [
                            {
                                "color": "#f3f1ee"
                            }
                        ]
                    },
                    {
                        "featureType": "road",
                        "elementType": "labels.text.stroke",
                        "stylers": [
                            {
                                "visibility": "off"
                            },
                            {
                                "color": "#929089"
                            }
                        ]
                    },
                    {
                        "featureType": "road.highway",
                        "elementType": "all",
                        "stylers": [
                            {
                                "visibility": "simplified"
                            }
                        ]
                    },
                    {
                        "featureType": "road.highway",
                        "elementType": "geometry.fill",
                        "stylers": [
                            {
                                "color": "#ffffff"
                            }
                        ]
                    },
                    {
                        "featureType": "road.highway",
                        "elementType": "labels",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "road.highway.controlled_access",
                        "elementType": "geometry.fill",
                        "stylers": [
                            {
                                "color": "#f3f1ee"
                            }
                        ]
                    },
                    {
                        "featureType": "road.arterial",
                        "elementType": "geometry.fill",
                        "stylers": [
                            {
                                "color": "#f3f1ee"
                            }
                        ]
                    },
                    {
                        "featureType": "road.arterial",
                        "elementType": "labels.icon",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "transit",
                        "elementType": "all",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "water",
                        "elementType": "all",
                        "stylers": [
                            {
                                "color": "#46bcec"
                            },
                            {
                                "visibility": "on"
                            }
                        ]
                    },
                    {
                        "featureType": "water",
                        "elementType": "geometry.fill",
                        "stylers": [
                            {
                                "color": "#acc2fa"
                            }
                        ]
                    },
                    {
                        "featureType": "water",
                        "elementType": "labels",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    }
                ]
            },
            // iconWidth: null,
            markers: [
            ],
        }
    },
    beforeCreate(){
        /* Icon marker size */
        // const screens = {
        //     'xs': '25',
        //     'sm': '25',
        //     'md': '12',
        //     'lg': '16',
        //     'xl': '30',
        //     'xxl': '30',
        // }

        // this.iconWidth = screens.xs;

        // if ( window.innerWidth >= 768 && window.innerWidth < 1024 ) {
        //     this.iconWidth = screens.sm;
        // } else if ( window.innerWidth >= 1024 && window.innerWidth < 1920 ) {
        //     this.iconWidth = screens.md;
        // } else if ( window.innerWidth >= 1920 ) {
        //     this.iconWidth = screens.xxl;
        // } else {
        //     this.iconWidth = screens.xs;
        // }
    },
    mounted() {
        this.getMarkers('food-and-drink');
    },
    methods: {
        getMarkers(cat, subCat = false) {
            let currentCenter = this.center;
            let tempCenter = { lat: 42.381918, lng: -71.1081096 };
            this.category = cat;
            this.subCategory = subCat;
            this.openMarker(null);
            

            let markers = [];
            let paths = [];

            this.data.filter(rep => {
                if (rep.category === this.category) {
                    
                    // Custom dates
                    rep.points.map((item, index) => {
                        
                        if ( item.transport_type === subCat || subCat === false ) {
                            markers.push({
                                id: item.google_map.place_id,
                                label: item.infowindow,
                                position: {
                                    lat: item.google_map.lat,
                                    lng: item.google_map.lng
                                },
                                path: {
                                    lines: ( item.path.lines ) ? this.filterLines(item.path.lines) : this.path,
                                    strokeColor: item.path.stroke_color,
                                },
                            });
                        }
                    });
                }
            });
            this.markers = markers;
            
            this.center = tempCenter;
            
            if ( this.markers[0] ) {
                setTimeout(() => {
                    this.openMarker(this.markers[0].id);
                    this.center = currentCenter;
                }, 300);
            }
        },
        openMarker(id) {
            // (this.openedMarkerID === id) ? this.openedMarkerID = null : this.openedMarkerID = id;
            this.openedMarkerID = id;
        },
        filterLines(lines) {
            let newLines = [];
            let line = lines.split("\n");
            
            for ( let i = 0; i < line.length; i++ ) {
                line[i] = line[i].trim();
                line[i] = line[i].replace(',0', '');
                
                const arrayLine = line[i].split(',');
                newLines.push({
                    lng: parseFloat(arrayLine[0]),
                    lat: parseFloat(arrayLine[1])
                });
            }
            
            return newLines;
        },
    }
}
</script>

<style lang="scss">
/*style the box which holds the text of the information window*/
.gm-style .gm-style-iw {
    background-color: #77A2FF !important;
    border-radius: 20px !important;
    padding: 9px 17px !important;
}

.gm-style .gm-style-iw-d::-webkit-scrollbar {
    display: none !important;
}




/*style the annoying little arrow at the bottom*/
.gm-style div div div div div div div div {
    background-color: #77A2FF !important;

}

.gm-style .gm-style-iw-t::after {
    background: linear-gradient(45deg,#77A2FF 50%,rgba(255,255,255,0) 51%,rgba(255,255,255,0) 100%) #77A2FF !important;
}

.gm-style .gm-style-iw-tc {  
    background-color: transparent !important;
}

.gm-style .gm-style-iw-tc::after {
    background: #77A2FF;
}

/* Close button */
.gm-ui-hover-effect {
    outline: none;
    display: none !important;

    > span {
        display: none !important;
    }
}

.poi-info-window a:link {
    background-color: #77A2FF !important;
    color: #000 !important;
}

</style>